module.exports = __webpack_public_path__ + "img/Group 60.21433c6e.png";